module.exports = __webpack_public_path__ + "static/media/yahoologo.cb874da4.png";